// Libs
import React, { useEffect, useState } from 'react';

// Own Libs
import { SimpleView, CompositeView, GridView } from '@digital/ui';

//Api
import {
  DemandaComRequisicao,
  getAllDemandasComRequisicaoComStatus
} from '@app/api/requisitanteCapex';
import { getDemandasPorStatusHistorico } from '@app/api/demanda';

//Files
import TabelaDemandas from './tabelaDemandas';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';
import TabelaDemandasValiadadaCancelada from './tabelaDemandasValidadaCancelada';
import { Visibility } from '@app/components';

//Utils

const Controladoria = () => {
  const result: DemandaComRequisicao[] = [];

  const [demandasAguardandoAnaliseControladoria, setDemandasAguardandoAnaliseControladoria] = useState<DemandaComRequisicao[]>();
  const [demandasStatusHistorico, setDemandasStatusHistorico] = useState<DemandaComRequisicao[]>();

  const allDemandasAguardandoAnaliseControladoria = async () => {
    const resultDemanda = await getAllDemandasComRequisicaoComStatus(EStatusDemanda.AguardandoAnaliseControladoria) || [];
    const resultDemandaModificacao = await getAllDemandasComRequisicaoComStatus(EStatusDemanda.AguardandoAnaliseControladoriaModificacao) || [];
    const resultDemandaReavaliacao = await getAllDemandasComRequisicaoComStatus(EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao) || [];
    setDemandasAguardandoAnaliseControladoria([...resultDemanda, ...resultDemandaModificacao, ...resultDemandaReavaliacao]);
  };

  const allDemandasStatusHistorico = async () => {
    const resultDemanda: any = await getDemandasPorStatusHistorico({
      listCodigoStatusDemanda: [EStatusDemanda.AguardandoAnaliseControladoria, EStatusDemanda.AguardandoAnaliseControladoriaModificacao, EStatusDemanda.AguardandoAnaliseControladoriaReavaliacao],
      listQuery: ['Aprovou', 'Devolveu', 'Cancelou']
    });

    if (resultDemanda) {
      setDemandasStatusHistorico(resultDemanda);
    }
  };

  useEffect(() => {
    allDemandasAguardandoAnaliseControladoria();
    allDemandasStatusHistorico();
  }, []);

  return (
    <SimpleView>
      <CompositeView>
        <GridView title="Pendencias Controladoria" icon="ui-in_progress" id="aguardandoValidacaoControladoria" noform>
          <TabelaDemandas
            dataSourceResult={demandasAguardandoAnaliseControladoria ? demandasAguardandoAnaliseControladoria : result}
            widgettitle={'Aguardando Validação Controladoria'}
            urlDemanda={'/demanda/questionario/'}
            aba={'/analise'}
          />
        </GridView>

        <GridView title="Validadas / Reprovadas" icon="ui-in_progress" id="validadasOuReprovadas" noform>
          <Visibility
            visible={demandasStatusHistorico && demandasStatusHistorico.length > 0}
          >
            <TabelaDemandasValiadadaCancelada
              dataSourceResult={demandasStatusHistorico ? demandasStatusHistorico : result}
              widgettitle={'Demandas Validadas ou Reprovadas pela Controladoria'}
              urlDemanda={'/demanda/questionario/'}
              aba={''}
            />
          </Visibility>
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};
export default Controladoria;
